import i18n from "@/language/i18n";
import PROJECT_MANAGEMENT_WIDGETS from "@/configuration/widgets/PROJECT_MANAGEMENT_WIDGETS";
import DEVICE_WIDGETS from "../widgets/DEVICE_WIDGETS";

const PRODUCT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    PRODUCT_MODULE_WINDOW_ID: 'products',
    PRODUCT_CATEGORIES_MODULE_WINDOW_ID: 'productcategories',
    PRODUCT_ATTRIBUTES_MODULE_WINDOW_ID: 'productattributes',
    DEVICES_MODULE_WINDOW_ID: 'devices',
});

export { PRODUCT_MODULE_WINDOW_IDENTIFIER };

export default {
    PRODUCT_GROUP_WRAPPER: {
        type: 'group',
        id: 'product',
        label: i18n.t('ModuleRegistry.groups.products.name'),
        children: [],
        icon: '$wPlanning',
        sidebarIcon: '$wNavProduct'
    },
    CHILDREN: {
        PRODUCT_MODULE: {
            type: 'module',
            id: 'products',
            windowIdentifierType: PRODUCT_MODULE_WINDOW_IDENTIFIER.PRODUCT_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.products.projectProducts.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/products',
            globalSearch: {
                index: 'products',
                presentation: i18n.t('ModuleRegistry.groups.products.projectProducts.label'),
                component: 'ProductItem',
            },
            widgets: PROJECT_MANAGEMENT_WIDGETS.PRODUCT_WIDGETS
        },
        PRODUCT_CATEGORIES_MODULE: {
            type: 'module',
            id: 'productCategories',
            windowIdentifierType: PRODUCT_MODULE_WINDOW_IDENTIFIER.PRODUCT_CATEGORIES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.products.productCategories.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/productcategories',
            globalSearch: {
                overrideRouterLink: '/productcategories',
                index: 'productcategories',
                routerLink: '/productcategories',
                presentation: i18n.t('ModuleRegistry.groups.products.productCategories.label'),
                component: 'ProductCategoryItem',
            },
        },
        PRODUCT_ATTRIBUTES_MODULE: {
            type: 'module',
            id: 'productattributes',
            windowIdentifierType: PRODUCT_MODULE_WINDOW_IDENTIFIER.PRODUCT_ATTRIBUTES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.products.productAttributes.label'),
            navigationImg: require('@/assets/navigation/items/icon_projectanfragen.svg'),
            routerLink: '/productattributes',
            globalSearch: {
                index: 'productattributes',
                routerLink: '/productattributes',
                presentation: i18n.t('ModuleRegistry.groups.products.productAttributes.label'),
                component: 'ProductAttributeItem',
            },
        },
        DEVICES_MODULE: {
            type: 'module',
            id: 'devices',
            windowIdentifierType: PRODUCT_MODULE_WINDOW_IDENTIFIER.DEVICES_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.products.devices.label'),
            navigationImg: require('@/assets/navigation/items/icon_krankmeldung.svg'),
            routerLink: '/devices',
            globalSearch: {
                index: 'devices',
                presentation: i18n.t('ModuleRegistry.groups.products.devices.label'),
                component: 'DeviceItem.vue',
                shortcut: '-d'
            },
            widgets: DEVICE_WIDGETS.DEVICE_WIDGETS
        },
    }
}
